module.exports = __webpack_public_path__ + "static/media/gpxcoinModal.eec8411a.png";